// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';
import maskInput from '../../../../utils/maskInput';
import DateRangePicker from '../../../common/DateRangePicker';
import dayjs from 'dayjs';
import formatNumberWithCommas from '../../../../helpers/numberWithCommasHelper';

export default class InvestmentView extends JQueryView {
  constructor() {
    super('.managements-container');

    this.render();
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: false,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs()
          .add(10, 'years')
          .toDate(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  @on({ event: 'click', selector: '.js-add-staff-button' })
  addSubStaffFields(event: any) {
    const addStaffButton = $(event.target);
    const subStaffFields = addStaffButton
      .parents('.investment-wrappar')
      .find('.sub_user_company_fields');
    const subStaffInput = subStaffFields.find('select');
    event.preventDefault();

    addStaffButton.addClass('d-none');
    subStaffFields.removeClass('d-none');
    subStaffInput.prop('disabled', false);

    this.filterSubUserCompanyOptions(event);
  }

  @on({ event: 'click', selector: '.remove-staff-button' })
  removeSubStaffFields(event: any) {
    const removeStaffButton = $(event.target);
    const addStaffButton = removeStaffButton
      .parents('.investment-wrappar')
      .find('.js-add-staff-button');
    const subStaffFields = removeStaffButton
      .parents('.investment-wrappar')
      .find('.sub_user_company_fields');
    const subStaffInput = subStaffFields.find('select');
    const userCompanyOptions = removeStaffButton
      .parents('.investment-wrappar')
      .find('.user_company_id option');
    const subUserCompanyFields = removeStaffButton
      .parents('.investment-wrappar')
      .find('.sub_user_company_id');
    event.preventDefault();

    addStaffButton.removeClass('d-none');
    subStaffFields.addClass('d-none');
    subStaffInput.prop('disabled', true);

    userCompanyOptions.each((index, element) => {
      $(element).show();
    });
    subUserCompanyFields.val(null);
  }

  @on({ event: 'input', selector: '.memo_fields textarea' })
  setMemoFields(event: any) {
    const memoInput = $(event.target);
    const memoLengthPreview = memoInput
      .parents('.memo_fields')
      .find('.memo-length-preview');
    const memoInputLength = memoInput.val().length;

    memoLengthPreview.text(memoInputLength);

    if (memoInputLength >= 0 && 1000 > memoInputLength) {
      memoLengthPreview.removeClass('danger');
    } else {
      memoLengthPreview.addClass('danger');
    }
  }

  @on({ event: 'change', selector: '.stock-type' })
  onChangeStockType(event: any) {
    const $form = $(event.target).parents('.investment-form');
    const selectedStockType = $form
      .find('.stock_type_fields select option:selected')
      .text();

    switch (selectedStockType) {
      case '普通株式':
        $form.find('.ordinary_share_fields').removeClass('d-none');
        $form.find('.ordinary_share_fields input').removeAttr('disabled');
        $form
          .find('.class_share_fields, .convertible_equity_fields')
          .addClass('d-none');
        $form
          .find('.class_share_fields input, .convertible_equity_fields input')
          .attr('disabled', 'disabled');
        break;
      case '種類株式':
        $form.find('.class_share_fields').removeClass('d-none');
        $form.find('.class_share_fields input').removeAttr('disabled');
        $form
          .find('.ordinary_share_fields, .convertible_equity_fields')
          .addClass('d-none');
        $form
          .find(
            '.ordinary_share_fields input, .convertible_equity_fields input',
          )
          .attr('disabled', 'disabled');
        break;
      case 'コンバーティブル・エクイティ':
        $form.find('.convertible_equity_fields').removeClass('d-none');
        $form.find('.convertible_equity_fields input').removeAttr('disabled');
        $form
          .find('.ordinary_share_fields, .class_share_fields')
          .addClass('d-none');
        $form
          .find('.ordinary_share_fields input, .class_share_fields input')
          .attr('disabled', 'disabled');
        break;
      default:
        $form
          .find(
            '.ordinary_share_fields, .class_share_fields, .convertible_equity_fields',
          )
          .addClass('d-none');
        $form
          .find(
            '.ordinary_share_fields input, .class_share_fields input, .convertible_equity_fields input',
          )
          .attr('disabled', 'disabled');
        break;
    }
  }

  // 普通株式・種類株式の取得時株価の自動計算
  @on({
    event: 'input',
    selector:
      '.cal_stock_price_fields .stock_quantity, .cal_stock_price_fields .investment_amount, .cal_stock_price_fields .sale_amount',
  })
  calStockPrice(event: any) {
    const calStockPriceFields = $(event.target).parents(
      '.cal_stock_price_fields',
    );
    const stockQuantity = parseFloat(
      calStockPriceFields
        .find('.stock_quantity')
        .val()
        .replace(/,/g, '') || 0,
    );

    const targetAmount = parseFloat(
      calStockPriceFields
        .find(
          $('.js-change_status').val() === 'exit'
            ? '.sale_amount'
            : '.investment_amount',
        )
        .val()
        .replace(/,/g, '') || 0,
    );

    // targetAmountが0の時・stockQuantityが0の時は、stock_priceは0
    let formatResult =
      stockQuantity === 0 || targetAmount === 0
        ? 0
        : (targetAmount / stockQuantity).toFixed(2);

    const result = formatNumberWithCommas(formatResult);

    const hiddenResult =
      stockQuantity === 0 || targetAmount === 0
        ? 0
        : targetAmount / stockQuantity;

    calStockPriceFields.find('.stock_price').val(result);
    calStockPriceFields.find('.hidden_stock_price').val(hiddenResult);
  }

  // コンバーティブル・エクイティの1個あたりの払込価格の自動計算
  @on({
    event: 'input',
    selector:
      '.cal_payment_unit_price_fields .quantity, .cal_payment_unit_price_fields .investment_amount',
  })
  calPaymentUnitPrice(event: any) {
    const calPaymentUnitPriceFields = $(event.target).parents(
      '.cal_payment_unit_price_fields',
    );
    const quantity = parseFloat(
      calPaymentUnitPriceFields
        .find('.quantity')
        .val()
        .replace(/,/g, '') || 0,
    );
    const investmentAmount = parseFloat(
      calPaymentUnitPriceFields
        .find('.investment_amount')
        .val()
        .replace(/,/g, '') || 0,
    );

    // investmentAmountが0の時・quantityが0の時は、payment_unit_priceは0
    let formatResult =
      quantity === 0 || investmentAmount === 0
        ? 0
        : (investmentAmount / quantity).toFixed(2);

    const result = formatNumberWithCommas(formatResult);

    const hiddenResult =
      quantity === 0 || investmentAmount === 0
        ? 0
        : investmentAmount / quantity;

    calPaymentUnitPriceFields.find('.payment_unit_price').val(result);
    calPaymentUnitPriceFields
      .find('.hidden_payment_unit_price')
      .val(hiddenResult);
  }

  initUserCompanyOptions() {
    const self = this;

    $('.user_company_id').each((index, element) => {
      self.filterSubUserCompanyOptions($(element));
    });
    $('.sub_user_company_id').each((index, element) => {
      self.filterUserCompanyOptions($(element));
    });
  }

  @on({ event: 'change', selector: '.user_company_id' })
  onChangeSubFilterUserCompanyOptions(event: any) {
    this.filterSubUserCompanyOptions(event.target);
  }

  filterSubUserCompanyOptions(target: any) {
    const invWrappar = $(target).parents('.investment-wrappar');
    const selectedUserId = invWrappar.find('.user_company_id').val();
    const subUserCompanyOptions = invWrappar.find(
      '.sub_user_company_id option',
    );

    subUserCompanyOptions.each((index, element) => {
      if (selectedUserId && $(element).val() === selectedUserId) {
        $(element).hide();
        $(element).removeAttr('selected');
      } else {
        $(element).show();
      }
    });
  }

  @on({ event: 'change', selector: '.sub_user_company_id' })
  onChangeFilterUserCompanyOptions(event: any) {
    this.filterUserCompanyOptions(event.target);
  }

  filterUserCompanyOptions(target: any) {
    const invWrappar = $(target).parents('.investment-wrappar');
    const selectedUserId = invWrappar.find('.sub_user_company_id').val();
    const userCompanyOptions = invWrappar.find('.user_company_id option');

    userCompanyOptions.each((index, element) => {
      if (selectedUserId && $(element).val() === selectedUserId) {
        $(element).hide();
        $(element).removeAttr('selected');
      } else {
        $(element).show();
      }
    });
  }

  initMemoFieldsOptions() {
    const memoInput = $('textarea');
    const memoLengthPreview = memoInput
      .parents('.memo_fields')
      .find('.memo-length-preview');
    const memoInputLength = memoInput.val().length;

    if (memoInputLength >= 0 && 1000 >= memoInputLength) {
      memoLengthPreview.removeClass('danger');
    } else {
      memoLengthPreview.addClass('danger');
    }
  }

  @on({ event: 'change', selector: '.js-change_status' })
  onChangeStatusControl(e: any) {
    e.preventDefault();
    const status = e.target.value;

    const $statusExit = $('.status_exit');
    const $statusOtherExit = $('.status_other_exit');
    const $changeLabelRound = $('.change-label-round');
    const $changeLabelTran = $('.change-label-tran');
    const $companyInvesteeInvestmentStockType = $(
      '#company_investee_investment_stock_type',
    );
    const $stockTypeFields = $('.stock_type_fields');
    const stockType = $('#company_investee_investment_stock_type').val();

    switch (status) {
      case 'exit':
        $statusExit.removeClass('d-none');
        $statusOtherExit.addClass('d-none');
        $changeLabelRound.text('売却時ラウンド');
        $changeLabelTran.text('売却日');
        $changeLabelTran.append($('<span class="required-mark">必須</span>'));
        $('.company_investee_investment_sale_date')
          .find('input')
          .removeAttr('disabled');
        $('.company_investee_investment_tran_on')
          .find('input')
          .attr('disabled', 'disabled');
        $('.tran_on_fields').addClass('d-none');
        $('.sale_date_fields').removeClass('d-none');
        $companyInvesteeInvestmentStockType.val('');
        $stockTypeFields.removeClass('d-flex').addClass('d-none');
        $stockTypeFields.find('select').attr('disabled', 'disabled');
        $statusExit.find('input').each((i, element) => {
          $(element).removeAttr('disabled');
        });
        $statusOtherExit.find('input, textarea').each((i, element) => {
          $(element).attr('disabled', 'disabled');
        });
        break;
      case 'invested':
        $statusExit.addClass('d-none');
        $statusOtherExit.removeClass('d-none');
        $changeLabelRound.text('投資時ラウンド');
        $changeLabelTran.text('投資日');
        $changeLabelTran.append($('<span class="required-mark">必須</span>'));
        $('.company_investee_investment_tran_on')
          .find('input')
          .removeAttr('disabled');
        $('.company_investee_investment_sale_date')
          .find('input')
          .attr('disabled', 'disabled');
        $('.tran_on_fields').removeClass('d-none');
        $('.sale_date_fields').addClass('d-none');
        $stockTypeFields.removeClass('d-none').addClass('d-flex');
        $stockTypeFields.find('select').removeAttr('disabled');
        $statusExit.find('input').each((i, element) => {
          $(element).attr('disabled', 'disabled');
        });
        if (stockType) {
          $statusOtherExit
            .children(`.${stockType}_fields`)
            .find('input')
            .each((i, element) => {
              $(element).removeAttr('disabled');
            });
        } else {
          $statusOtherExit.find('input').each((i, element) => {
            $(element).removeAttr('disabled');
          });
        }
        break;
      default:
        $statusExit.addClass('d-none');
        $statusOtherExit.removeClass('d-none');
        $changeLabelRound.text('投資時ラウンド');
        $changeLabelTran.text('投資日');
        $changeLabelTran.find('span').remove();
        $('.company_investee_investment_tran_on')
          .find('input')
          .removeAttr('disabled');
        $('.company_investee_investment_sale_date')
          .find('input')
          .attr('disabled', 'disabled');
        $('.tran_on_fields').removeClass('d-none');
        $('.sale_date_fields').addClass('d-none');
        $stockTypeFields.removeClass('d-none').addClass('d-flex');
        $stockTypeFields.find('select').removeAttr('disabled');
        $statusExit.find('input').each((i, element) => {
          $(element).attr('disabled', 'disabled');
        });
        if (stockType) {
          $statusOtherExit
            .children(`.${stockType}_fields`)
            .find('input')
            .each((i, element) => {
              $(element).removeAttr('disabled');
            });
        } else {
          $statusOtherExit.find('input').each((i, element) => {
            $(element).removeAttr('disabled');
          });
        }
        break;
    }
  }

  @on({ event: 'change', selector: '.js-date_format' })
  onChangeDateFormat(e: any) {
    const date = e.target.value;
    $('.js-date_format').val(
      date.replace(/(\d{4})\/(\d{2})\/\d{2}/, '$1年$2月'),
    );
  }

  render() {
    maskInput();
    this.initDateRangePicker(this.$el);
    this.initUserCompanyOptions();
    this.initMemoFieldsOptions();
  }
}
